<template>
  <div
    class="flex items-center justify-center bg-dark rounded-full text-white text-center"
    :class="{
      'invisible pointer-events-none opacity-0': !name,
      'cursor-pointer': $listeners.click
    }"
    :style="{
      height: size + 'px',
      width: size + 'px'
    }"
    @click="$emit('click')"
  >
    {{ name ? defineAbbr(name).slice(0, letters) : '' }}
  </div>
</template>

<script>
import { defineAbbr } from '@/utils/base'

export default {
  name: 'BaseAvatar',

  props: {
    size: { type: Number, default: 32 },
    letters: { type: Number, default: 2 },
    name: { type: String, default: '' }
  },

  created() {
    this.defineAbbr = defineAbbr
  }
}
</script>
